import { Event } from '@legacy-types';

import { ContextSelector } from '@shared/layout/components/ContextSelector';

import { GlobalSearch } from '@admin/layout/components/GlobalSearch';

type AdminHeaderProps = {
  event: Event;
  events: Event[];
  onEventChange: (event: Event) => void;
};

export function AdminHeader({ event, events, onEventChange }: AdminHeaderProps) {
  return (
    <div className="flex flex-wrap items-center gap-3 lg:gap-6">
      <ContextSelector
        selected={event}
        options={events}
        icon="calendar-2"
        label={(event) => event.name}
        onSelect={onEventChange}
      />
      <div className="flex-1 min-w-48 lg:min-w-80 w-full lg:w-auto">
        <GlobalSearch />
      </div>
    </div>
  );
}
